import { cva } from "class-variance-authority";

export const radioContainerCva = cva("flex flex-row items-center", {
  variants: {
    disabled: {
      true: "opacity-50 cursor-not-allowed",
      false: "group",
    },
  },
  defaultVariants: {
    disabled: false,
  },
});

export const radioLabelCva = cva("text-theme-light-text dark:text-theme-dark-text cursor-pointer select-none", {
  variants: {
    position: {
      left: "mr-2.5",
      right: "ml-2.5",
    },
    size: {
      "is-large": "text-base leading-5",
      "is-medium": "text-sm leading-4",
      "is-small": "text-sm leading-4",
    },
    disabled: {
      true: "cursor-not-allowed",
      false: "",
    },
  },
  defaultVariants: {
    position: "left",
    size: "is-medium",
    disabled: false,
  },
});

export const radioCustomCva = cva(
  "flex items-center justify-center border rounded-full peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-1",
  {
    variants: {
      size: {
        "is-large": "h-5 w-5",
        "is-medium": "h-4 w-4",
        "is-small": "h-3.5 w-3.5",
      },
      disabled: {
        true: "border-gray-300 bg-gray-100 cursor-not-allowed",
        false: "border-primary-500 cursor-pointer",
      },
    },
    defaultVariants: {
      size: "is-medium",
      disabled: false,
    },
  },
);

export const radioDotCva = cva("rounded-full transition-opacity duration-100 ease-in-out", {
  variants: {
    size: {
      "is-large": "h-2.5 w-2.5",
      "is-medium": "h-2 w-2",
      "is-small": "h-1.5 w-1.5",
    },
    disabled: {
      true: "bg-gray-300",
      false: "bg-primary-500",
    },
    selected: {
      true: "opacity-100",
      false: "opacity-0 group-hover:opacity-25",
    },
  },
  defaultVariants: {
    size: "is-medium",
    disabled: false,
    selected: false,
  },
});
